module.exports = __webpack_public_path__ + "img/icon_menu4.5f00bc17.jpg";